"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const raw_settings = __importStar(require("@/genfiles/settings.json"));
const paths_1 = require("@/common/app/paths");
exports.default = (0, vue_1.defineComponent)({
    name: 'login-home',
    data() {
        return {
            user: undefined,
            discordClientId: raw_settings.discordClientId,
        };
    },
    mounted() {
        const url = paths_1.paths.API_PROFILE;
        fetch(url)
            .then((resp) => {
            if (!resp.ok) {
                console.error('Unexpected server response: ' + resp.statusText);
                return null;
            }
            return resp.json();
        })
            .then((data) => {
            if (!data)
                return;
            try {
                this.user = data._user.userid;
            }
            catch (e) {
                console.log('Error processing fetch response: ' + e);
            }
        })
            .catch((err) => {
            alert('Error getting session profile data');
            console.error(err);
        });
    },
    computed: {
        loginUrl() {
            const thisUrl = window.location.href;
            const idx = window.location.href.lastIndexOf('/' + paths_1.paths.LOGIN);
            const url = thisUrl.substring(0, idx) + '/' + paths_1.paths.AUTH_DISCORD_CALLBACK;
            const encoded = encodeURI(url);
            const clientId = this.discordClientId;
            if (!clientId)
                return '';
            return 'https://discord.com/oauth2/authorize?client_id=' + clientId + '&response_type=code&scope=identify&redirect_uri=' + encoded;
        },
        logoutURL() {
            return paths_1.paths.API_LOGOUT;
        },
    },
});
